import Vue from 'vue';
import Vuex from 'vuex';
import {state} from './state.js'
import {mutations} from './mutations.js'


import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);
window.keyAMS = window.pipwerks.SCORM.get("cmi.core.student_id");

if(window.keyAMS == 'null'){
	if(window.location.hostname == 'localhost'){
		window.keyAMS = 'emuladorams';
	}else{
		window.keyAMS = 'emuladorams-'+(new Date().getTime()).toString(36);
	}
}

window.realUrl = window.location.href;

export const store = new Vuex.Store({
	state,
	mutations,
	plugins: [createPersistedState({key:window.keyAMS})],
});